var _path, _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 36 34",
    style: {
      enableBackground: "new 0 0 36 34"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 8c.5 0 1 .5 1 1.1v12.5c0 .6-.4 1.1-1 1.1h-6.5c-.6 0-1.2.2-1.6.6L16 25.7v-.4c0-1.4-1.1-2.5-2.5-2.5H9c-.5 0-1-.5-1-1.1V9.1C8 8.5 8.5 8 9 8h18m0-2H9C7.3 6 6 7.4 6 9.1v12.5c0 1.7 1.3 3.1 3 3.1h4.5c.3 0 .5.2.5.5v3.7c0 .3.2.5.5.5.1 0 .2 0 .3-.1l5.4-4.4c.1-.1.2-.1.3-.1H27c1.7 0 3-1.4 3-3.1V9.1C30 7.4 28.7 6 27 6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 14,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 11,
    height: 2
  })));
};

export default SvgComment;